import React from "react";
import { HStack, Checkbox, Text } from "@chakra-ui/react";

interface FileItemProps {
  doc: DocumentItem;
  selectedFile: DocumentItem | null;
  onSelect: (file: DocumentItem) => void;
}

export const FileItem: React.FC<FileItemProps> = ({
  doc,
  selectedFile,
  onSelect,
}) => {
  const isChecked = selectedFile?.id === doc?.id;

  return (
    <HStack
      py={1}
      pl={2}
      _hover={{ bg: "gray.50" }}
      cursor="pointer"
      borderRadius="md"
      onClick={() => onSelect(doc)}
    >
      <Checkbox
        isChecked={isChecked}
        onChange={() => onSelect(doc)}
        size="sm"
      />
      <Text fontSize="sm">{doc?.fileName_key}</Text>
    </HStack>
  );
};
